import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchGroupes } from 'store/groupe/groupeActions';
import { openAddActionDialog } from 'store/common/commonActions';

import ActionsSpecifiquesSelect from './ActionsSpecifiquesSelect';

class ActionsSpecifiquesSelectContainer extends React.Component {

    componentDidMount() {
        this.props.fetchGroupes();
    }

    handleClickItem = (event) => {
        const { actions, reclamationId, openAddActionDialog } = this.props;

        let actionId = event.target.value;

        let action = actions.find(a => a.id === actionId);
        
        openAddActionDialog(reclamationId, action);
    };

    render() {
        const { actions, iconButtonSx, reclamationSurBonDeVenteCle } = this.props;

        if (actions === undefined || actions === null) {
            return null;
        }

        return (
            <ActionsSpecifiquesSelect
                actions={actions}
                onClickItem={this.handleClickItem}
                iconButtonSx={iconButtonSx}
                reclamationSurBonDeVenteCle={reclamationSurBonDeVenteCle}
            />
        );
    }
}

const mapStateToProps = (state, props) => {

    let groupe = state.groupe.groupes.items.find(x => x.id === props.groupeId);

     return {
        actions: groupe ? groupe.actions : null
    };

};

const mapDispatchToProps = dispatch => ({
    fetchGroupes: () => dispatch(fetchGroupes()),
    openAddActionDialog: (reclamationId, action) => dispatch(openAddActionDialog(reclamationId, action))
});

ActionsSpecifiquesSelectContainer.propTypes = {

    reclamationId: PropTypes.number.isRequired,
    groupeId: PropTypes.number.isRequired,
    reclamationSurBonDeVenteCle: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionsSpecifiquesSelectContainer);